import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsOfService = () => {
  return (
    <>
      <Helmet>
        <title>Điều khoản sử dụng - KiểmTraNăngLực</title>
        <meta name="description" content="Điều khoản và điều kiện sử dụng dịch vụ test trực tuyến của KiểmTraNăngLực. Vui lòng đọc kỹ trước khi sử dụng." />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl mb-6">
              <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
              </svg>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Điều khoản sử dụng
            </h1>
            <p className="text-gray-600">
              Cập nhật lần cuối: {new Date().toLocaleDateString('vi-VN')}
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
            {/* Introduction */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-blue-600 font-bold">1</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Chấp nhận điều khoản</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Bằng việc truy cập và sử dụng website KiểmTraNăngLực (kiemtranangluc.online), bạn đồng ý tuân thủ 
                    và bị ràng buộc bởi các điều khoản và điều kiện sử dụng này. Nếu bạn không đồng ý với 
                    bất kỳ phần nào của các điều khoản này, vui lòng không sử dụng dịch vụ của chúng tôi.
                  </p>
                </div>
              </div>
            </section>

            {/* Service Description */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-purple-600 font-bold">2</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Mô tả dịch vụ</h2>
                  <div className="space-y-3 text-gray-600">
                    <p>KiểmTraNăngLực cung cấp các dịch vụ test trực tuyến miễn phí bao gồm:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li>Test IQ - Đánh giá chỉ số thông minh</li>
                      <li>Test MBTI - Phân tích tính cách</li>
                      <li>Test EQ - Đánh giá trí tuệ cảm xúc</li>
                      <li>Test DISC - Phân tích phong cách hành vi</li>
                      <li>Holland Codes - Định hướng nghề nghiệp</li>
                    </ul>
                    <p className="mt-3">
                      Các kết quả test chỉ mang tính chất tham khảo và không thay thế cho đánh giá 
                      chuyên môn từ các chuyên gia tâm lý hoặc giáo dục.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* User Responsibilities */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-green-600 font-bold">3</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Trách nhiệm người dùng</h2>
                  <div className="space-y-3 text-gray-600">
                    <p>Khi sử dụng dịch vụ của chúng tôi, bạn đồng ý:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li>Cung cấp thông tin chính xác và trung thực</li>
                      <li>Không sử dụng dịch vụ cho mục đích bất hợp pháp</li>
                      <li>Không can thiệp hoặc phá hoại hệ thống website</li>
                      <li>Không sao chép, phân phối nội dung mà không có sự cho phép</li>
                      <li>Không sử dụng bot, script hoặc công cụ tự động để truy cập dịch vụ</li>
                      <li>Tuân thủ tất cả các luật và quy định hiện hành</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Intellectual Property */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-yellow-600 font-bold">4</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Quyền sở hữu trí tuệ</h2>
                  <div className="space-y-3 text-gray-600">
                    <p>
                      Tất cả nội dung trên website KiểmTraNăngLực, bao gồm nhưng không giới hạn ở văn bản, 
                      hình ảnh, logo, biểu tượng, câu hỏi test, thuật toán chấm điểm, đều thuộc quyền 
                      sở hữu của KiểmTraNăngLực hoặc các bên cấp phép.
                    </p>
                    <p>
                      Bạn không được phép sao chép, sửa đổi, phân phối, truyền tải, hiển thị, thực hiện, 
                      tái tạo, xuất bản, cấp phép, tạo các tác phẩm phái sinh, chuyển giao hoặc bán bất kỳ 
                      thông tin, phần mềm, sản phẩm hoặc dịch vụ nào có được từ website mà không có sự 
                      đồng ý bằng văn bản từ KiểmTraNăngLực.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Test Results */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-red-600 font-bold">5</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Kết quả test và độ chính xác</h2>
                  <div className="space-y-3 text-gray-600">
                    <p className="font-semibold text-gray-800">Tuyên bố miễn trừ trách nhiệm:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li>Kết quả test chỉ mang tính chất tham khảo và giải trí</li>
                      <li>Không thay thế cho đánh giá chuyên môn từ chuyên gia tâm lý</li>
                      <li>Độ chính xác phụ thuộc vào sự trung thực khi trả lời câu hỏi</li>
                      <li>Chúng tôi không chịu trách nhiệm về các quyết định dựa trên kết quả test</li>
                      <li>Kết quả có thể thay đổi theo thời gian và hoàn cảnh</li>
                    </ul>
                    <p className="mt-3 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                      <strong className="text-yellow-800">Lưu ý quan trọng:</strong> Nếu bạn cần đánh giá 
                      chính xác cho mục đích học tập, nghề nghiệp hoặc y tế, vui lòng tham khảo ý kiến 
                      từ các chuyên gia có chứng chỉ hành nghề.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Privacy */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-indigo-600 font-bold">6</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Quyền riêng tư</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Việc sử dụng dịch vụ của chúng tôi cũng được điều chỉnh bởi 
                    <a href="/privacy-policy" className="text-blue-600 hover:underline mx-1">
                      Chính sách bảo mật
                    </a>
                    của chúng tôi. Vui lòng xem lại chính sách này để hiểu cách chúng tôi thu thập, 
                    sử dụng và bảo vệ thông tin cá nhân của bạn.
                  </p>
                </div>
              </div>
            </section>

            {/* Limitation of Liability */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-pink-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-pink-600 font-bold">7</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Giới hạn trách nhiệm</h2>
                  <div className="space-y-3 text-gray-600">
                    <p>
                      KiểmTraNăngLực và các bên liên quan không chịu trách nhiệm về:
                    </p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li>Bất kỳ thiệt hại trực tiếp, gián tiếp, ngẫu nhiên hoặc hậu quả nào</li>
                      <li>Mất mát dữ liệu hoặc lợi nhuận phát sinh từ việc sử dụng dịch vụ</li>
                      <li>Gián đoạn dịch vụ hoặc lỗi kỹ thuật</li>
                      <li>Hành vi của người dùng khác trên nền tảng</li>
                      <li>Nội dung hoặc độ chính xác của thông tin từ bên thứ ba</li>
                    </ul>
                    <p className="mt-3">
                      Dịch vụ được cung cấp "nguyên trạng" và "sẵn có" mà không có bất kỳ bảo đảm nào, 
                      dù rõ ràng hay ngụ ý.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Service Modifications */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-orange-600 font-bold">8</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Thay đổi và chấm dứt dịch vụ</h2>
                  <div className="space-y-3 text-gray-600">
                    <p>Chúng tôi có quyền:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4">
                      <li>Sửa đổi, tạm ngưng hoặc ngừng cung cấp dịch vụ bất kỳ lúc nào</li>
                      <li>Thay đổi nội dung, tính năng hoặc giao diện của website</li>
                      <li>Từ chối hoặc chấm dứt quyền truy cập của người dùng vi phạm điều khoản</li>
                      <li>Xóa hoặc chỉnh sửa nội dung không phù hợp</li>
                    </ul>
                    <p className="mt-3">
                      Chúng tôi sẽ cố gắng thông báo trước về các thay đổi quan trọng, nhưng không 
                      có nghĩa vụ phải làm như vậy.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Third Party Links */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-teal-600 font-bold">9</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Liên kết bên thứ ba</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Website của chúng tôi có thể chứa liên kết đến các trang web bên thứ ba. Chúng tôi 
                    không kiểm soát và không chịu trách nhiệm về nội dung, chính sách bảo mật hoặc 
                    thực tiễn của bất kỳ trang web bên thứ ba nào. Bạn truy cập các liên kết này với 
                    rủi ro của riêng mình.
                  </p>
                </div>
              </div>
            </section>

            {/* Governing Law */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-cyan-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-cyan-600 font-bold">10</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Luật áp dụng</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Các điều khoản này được điều chỉnh và giải thích theo luật pháp Việt Nam. 
                    Mọi tranh chấp phát sinh từ hoặc liên quan đến các điều khoản này sẽ được 
                    giải quyết tại tòa án có thẩm quyền tại Hà Nội, Việt Nam.
                  </p>
                </div>
              </div>
            </section>

            {/* Changes to Terms */}
            <section>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-8 h-8 bg-violet-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-violet-600 font-bold">11</span>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">Thay đổi điều khoản</h2>
                  <p className="text-gray-600 leading-relaxed">
                    Chúng tôi có quyền cập nhật hoặc thay đổi các điều khoản này bất kỳ lúc nào. 
                    Các thay đổi sẽ có hiệu lực ngay khi được đăng tải trên trang này. Việc bạn 
                    tiếp tục sử dụng dịch vụ sau khi có thay đổi đồng nghĩa với việc bạn chấp nhận 
                    các điều khoản mới.
                  </p>
                </div>
              </div>
            </section>

            {/* Contact */}
            <section className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-100">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-800 mb-3">Liên hệ với chúng tôi</h2>
                  <p className="text-gray-600 mb-3">
                    Nếu bạn có bất kỳ câu hỏi nào về Điều khoản sử dụng này, vui lòng liên hệ:
                  </p>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Email:</strong> <a href="mailto:nguyenhuynhduc120597@gmail.com" className="text-blue-600 hover:underline">nguyenhuynhduc120597@gmail.com</a></p>
                    <p><strong>Hotline:</strong> <a href="tel:0927663809" className="text-blue-600 hover:underline">0927663809</a></p>
                    <p><strong>Địa chỉ:</strong> 30 Đường Thị Mười, Phường TTH, Quận 12, TPHCM</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Acceptance */}
            <section className="bg-gray-50 rounded-xl p-6 border-2 border-gray-200">
              <p className="text-gray-700 text-center">
                <strong>Bằng việc sử dụng dịch vụ của KiểmTraNăngLực, bạn xác nhận rằng bạn đã đọc, 
                hiểu và đồng ý với tất cả các điều khoản và điều kiện nêu trên.</strong>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;

